import { services } from '../../../../constants/services';
import { removeWithQueryParams } from '../../../../utils/api';

export class DeleteUserCampusService {
  async run( userCampusId: any ) {
    const response = await removeWithQueryParams(`${services.userCampus}/deleteUserCampus`, { userCampusId: userCampusId });
    return response;
  };
};